import { Component, Input, Output, EventEmitter, OnChanges }    from '@angular/core';
import {PaginationService}                           from './pagination.service';
import {BehaviorSubject}                             from 'rxjs/BehaviorSubject';
declare var $: any;


@Component({
    selector: 'pagination2',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.css']
})

export class PaginationComponent2 implements OnChanges {

  @Input('pagination')   pagination: any;
  @Output() onChangePage: EventEmitter<any> = new EventEmitter();
  resultsPerPageOptions = [25, 50, 100, 200];
  current_page = 1;

  private translates: Object = {};

  public buttoms: any[];
  public paginationPage:any;

  constructor(
    private paginationService: PaginationService) {
  }

  changePage(page:any){
    if(page > 0 && page <= this.pagination.lastPage && !isNaN(page)) {
      this.current_page = page;
      this.onChangePage.emit(page);
      this.buttoms = this.paginationService.getPaginationPages(this.pagination.currentPage, this.pagination.lastPage, 7);
    };
     this.smoothScrollTop();
    //  this.resizable(document.getElementById('counter-input'),8.3);
  }

  resizable(el, factor) {
    var int = Number(factor) || 7.7;
    function resize() {el.style.width = ((el.value.length+1) * int) + 'px'}
    var e = 'keyup,keypress,focus,blur,change'.split(',');
    for (var i in e) el.addEventListener(e[i],resize,false);
    resize();
  }

  smoothScrollTop() {
      $("html, body").animate({ scrollTop: 0 }, "fast");
  }


  ngOnChanges(changes ?: any){
    this.buttoms = this.paginationService.getPaginationPages(this.pagination.currentPage, this.pagination.lastPage, 7);
    this.changePage(1);
  }
}



// WEBPACK FOOTER //
// ./src/app/pagination2/pagination.component.ts